var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLookupList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_71_5",
    "data-name": "Component 71 \\u2013 5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.317,
    height: 18,
    viewBox: "0 0 22.317 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "playlist-plus_2_",
    "data-name": "playlist-plus (2)",
    d: "M21.906,6H2V8H21.906",
    transform: "translate(24.317 24) rotate(180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "playlist-plus_2_2",
    "data-name": "playlist-plus (2)",
    d: "M21.906,6H2V8H21.906",
    transform: "translate(24.317 20) rotate(180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "playlist-plus_2_3",
    "data-name": "playlist-plus (2)",
    d: "M9.415,6H2V8H9.415",
    transform: "translate(24.317 16) rotate(180)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "playlist-plus_2_4",
    "data-name": "playlist-plus (2)",
    d: "M7.975,6H2V8H7.975",
    transform: "translate(24.317 12) rotate(180)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "eye-outline_3_",
    "data-name": "eye-outline (3)",
    d: "M8.3,7.487A1.991,1.991,0,1,1,6.31,9.478,1.991,1.991,0,0,1,8.3,7.487M8.3,4.5a7.85,7.85,0,0,1,7.3,4.978,7.843,7.843,0,0,1-14.6,0A7.85,7.85,0,0,1,8.3,4.5M2.447,9.478a6.519,6.519,0,0,0,11.709,0,6.519,6.519,0,0,0-11.709,0Z",
    transform: "translate(-1 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookupList);
export default __webpack_public_path__ + "static/media/lookup_list.4bb2ac2bc749c7f4c93c805dd6325d45.svg";
export { ForwardRef as ReactComponent };